import { useParams } from 'react-router-dom';

import { usePathSet } from '@/hooks/usePathSet';
import { buildPath } from '@/utils/buildPath';
import { UnexpectedMissingDataError } from '@/utils/errors/UnexpectedMissingDataError';

import { usePlotForm } from '../../../hooks/usePlotForm';

export const usePreviousPath = () => {
  const form = usePlotForm();
  const { plotId } = useParams();
  const pathSet = usePathSet();

  if (!plotId) {
    throw new UnexpectedMissingDataError({ dataLabels: { plotId } });
  }

  const previousPathFromFormValues = form.getValues().custom?.previousPath;

  if (typeof previousPathFromFormValues === 'string') {
    return previousPathFromFormValues;
  }

  return buildPath(pathSet.plot, { pathParams: { plotId } });
};
